@if (loadingState() === 'loaded' && creatorCount() > 0) {
<div
    class="w-full flex flex-col divide-y divide-gray-100 dark:divide-white/10 overflow-hidden shadow-card-container-pale">
    <div class="shrink-0 p-2 flex flex-row flex-wrap items-center justify-between gap-2">
        <div class="flex min-w-0 items-center flex-1">
            <div class="shrink-0">
                <div
                    class="size-10 rounded-xl bg-teal-500/20 text-teal-500 text-sm font-semibold flex items-center justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-6" aria-hidden="true">
                        <path d="M18 21a8 8 0 0 0-16 0" />
                        <circle cx="10" cy="8" r="5" />
                        <path d="M22 20c0-3.37-2-6.5-4-8a5 5 0 0 0-.45-8.3" />
                    </svg>
                </div>
            </div>
            <div class="ml-4 min-w-0">
                <h3 class="text-md font-semibold text-primary">{{ heading() }}</h3>
                <p class="m-0 text-sm text-secondary">{{ subtitle() }}</p>
            </div>
        </div>

        <button type="button" (click)="seeAll()"
            class="shrink-0 secondary-button text-secondary inline-flex flex-row items-center gap-x-2">
            @if (creatorCount() === 1) {
            See Creator
            } @else {
            See all
            }
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="size-5 text-secondary" aria-hidden="true">
                <path d="M5 12h14" />
                <path d="m12 5 7 7-7 7" />
            </svg>
        </button>
    </div>

    <div class="flex items-center gap-4 p-4 overflow-x-auto scrollbar-transparent">
        @for (creator of previewCreators(); track creator.blazeFirebaseUid) {
        <button type="button" (click)="openCreator(creator)"
            class="flex flex-col gap-2 items-center justify-center shrink-0">
            <div class="size-16 rounded-lg overflow-hidden">
                <img [src]="imageService.getImageSource(creator.photoURL, 'gallery_lg')"
                    [alt]="creatorDisplayName(creator)" class="size-16 object-cover rounded-lg">
            </div>
            <p class="m-0 text-xs font-semibold text-primary">{{ creatorDisplayName(creator) }}</p>
        </button>
        }

        @if (extraCount() > 0) {
        <a routerLink="/creators-my-groups" [queryParams]="interestedCreatorsQueryParams"
            class="flex flex-col gap-2 items-center justify-center shrink-0 no-underline">
            <div
                class="size-16 rounded-lg overflow-hidden flex items-center justify-center bg-gray-300 dark:bg-white/20">
                <p class="m-0 text-2xl font-semibold text-white">+{{ extraCount() }}</p>
            </div>
            <p class="m-0 text-xs font-semibold text-secondary">more</p>
        </a>
        }
    </div>
</div>
}

@if (magicSearchService.portfolioCreatorId()) {
<cc-creator-profile [creator]="magicSearchService.portfolioCreator()!"></cc-creator-profile>
}
